var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 147,
    viewBox: "0 0 137 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 146.022C0 108.444 30.4667 78 68.0222 78C105.578 78 136.044 108.467 136.044 146.022",
    fill: "url(#paint0_linear_10391_36887)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10391_36887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9484 3.2657L29.0328 37.624L52.1803 107.581L68.9918 111.098L74.6167 104.976L71.8443 30.1311L43.9484 3.2657Z",
    fill: "url(#paint1_linear_10391_36887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6818 47.1924L29.0329 37.6241L52.1803 107.581L68.9918 111.098L74.6167 104.977L71.8444 30.1313L56.6818 47.1924Z",
    fill: "url(#paint2_linear_10391_36887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.582 5.44971L56.6824 47.1917L66.314 36.3556L58.8783 40.0019L44.582 5.44971Z",
    fill: "url(#paint3_linear_10391_36887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3142 36.3558L61.3206 48.4687L67.9426 102.967L56.7439 47.3558L66.3142 36.3558Z",
    fill: "url(#paint4_linear_10391_36887)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.8137 33.5379L43.9492 3.26611L67.758 34.7272L72.5857 85.6184L68.8137 33.5379Z",
    fill: "url(#paint5_linear_10391_36887)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.4748 39.8527L43.9497 3.26606L39.1312 41.0599L58.6696 108.939L35.4748 39.8527Z",
    fill: "url(#paint6_linear_10391_36887)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6836 20.3481L71.8437 30.1316L73.2626 68.5404L70.6105 31.5144L61.6836 20.3481Z",
    fill: "url(#paint7_linear_10391_36887)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.601 23.254L85.2168 40.8395L72.4894 98.5985L82.645 107.921L89.0368 106.006L117.827 53.2319L109.601 23.254Z",
    fill: "url(#paint8_linear_10391_36887)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.366 58.7825L85.2163 40.8394L72.4888 98.5984L82.6444 107.921L89.0362 106.005L117.826 53.2318L100.366 58.7825Z",
    fill: "url(#paint9_linear_10391_36887)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.143 25.0205L100.368 58.7824L111.458 55.2575L104.832 54.7229L109.143 25.0205Z",
    fill: "url(#paint10_linear_10391_36887)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.457 55.2578L103.043 61.5662L85.2558 101.881L100.342 58.9209L111.457 55.2578Z",
    fill: "url(#paint11_linear_10391_36887)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.338 54.3386L109.602 23.2542L113.122 54.726L95.5762 91.8167L114.338 54.3386Z",
    fill: "url(#paint12_linear_10391_36887)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M88.7469 45.0189L109.602 23.2539L90.7743 47.3517L76.4094 102.197L88.7469 45.0189Z",
    fill: "url(#paint13_linear_10391_36887)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.83 42.3142L117.826 53.2317L103.05 80.3123L116.408 53.6798L114.83 42.3142Z",
    fill: "url(#paint14_linear_10391_36887)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2281 47.774L60.0476 64.9597L58.8325 111.38L68.0488 117.055L72.6911 114.627L87.0304 69.6595L76.2281 47.774Z",
    fill: "url(#paint15_linear_10391_36887)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3981 76.5371L60.0485 64.9597L58.8334 111.38L68.0497 117.055L72.6919 114.627L87.0313 69.6596L74.3981 76.5371Z",
    fill: "url(#paint16_linear_10391_36887)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1367 49.2041L74.397 76.5368L82.4216 72.1689L77.2344 72.7429L76.1367 49.2041Z",
    fill: "url(#paint17_linear_10391_36887)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4213 72.1692L76.8739 78.2845L69.1621 112.01L74.398 76.6473L82.4213 72.1692Z",
    fill: "url(#paint18_linear_10391_36887)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.5061 71.0317L76.2285 47.7739L83.6262 71.5114L75.6208 102.716L84.5061 71.0317Z",
    fill: "url(#paint19_linear_10391_36887)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.3899 67.6563L76.2276 47.774L65.3 69.1528L62.3888 113.57L63.3899 67.6563Z",
    fill: "url(#paint20_linear_10391_36887)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0957 61.6892L87.0303 69.6595L79.6695 92.7349L86.0039 70.216L83.0957 61.6892Z",
    fill: "url(#paint21_linear_10391_36887)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10391_36887",
    x1: 68.466,
    y1: 123.864,
    x2: 69.3746,
    y2: 78.4332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C253D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7778,
    stopColor: "#26304B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10391_36887",
    x1: 70.2639,
    y1: 58.848,
    x2: 28.0529,
    y2: 60.0852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10391_36887",
    x1: 50.6092,
    y1: 38.29,
    x2: 59.0616,
    y2: 108.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95597,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10391_36887",
    x1: 63.992,
    y1: 51.3576,
    x2: 47.6679,
    y2: 34.7274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10391_36887",
    x1: 67.6973,
    y1: 71.1695,
    x2: 57.6938,
    y2: 71.6671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10391_36887",
    x1: 71.6709,
    y1: 45.0439,
    x2: 58.299,
    y2: 26.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732292,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10391_36887",
    x1: 48.5797,
    y1: 70.271,
    x2: 22.913,
    y2: 44.8325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10391_36887",
    x1: 72.049,
    y1: 45.2892,
    x2: 62.7411,
    y2: 45.7196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10391_36887",
    x1: 104.956,
    y1: 72.3956,
    x2: 75.3269,
    y2: 55.9337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10391_36887",
    x1: 99.8288,
    y1: 50.1497,
    x2: 76.7094,
    y2: 102.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95597,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10391_36887",
    x1: 103.702,
    y1: 64.6549,
    x2: 99.2615,
    y2: 46.4853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10391_36887",
    x1: 98.1302,
    y1: 79.8434,
    x2: 91.0245,
    y2: 76.0831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10391_36887",
    x1: 111.589,
    y1: 63.4488,
    x2: 109.808,
    y2: 45.4445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732292,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10391_36887",
    x1: 85.3102,
    y1: 71.3805,
    x2: 78.0376,
    y2: 43.3015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10391_36887",
    x1: 111.75,
    y1: 63.7732,
    x2: 105.152,
    y2: 60.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10391_36887",
    x1: 79.961,
    y1: 86.3482,
    x2: 54.67,
    y2: 78.0676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10391_36887",
    x1: 72.6988,
    y1: 69.9621,
    x2: 62.639,
    y2: 113.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95597,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10391_36887",
    x1: 77.8413,
    y1: 80.5677,
    x2: 71.7141,
    y2: 67.2217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10391_36887",
    x1: 75.8069,
    y1: 93.1054,
    x2: 69.7696,
    y2: 91.2642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10391_36887",
    x1: 83.743,
    y1: 78.4638,
    x2: 79.6899,
    y2: 64.8496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732292,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10391_36887",
    x1: 64.664,
    y1: 88.4897,
    x2: 54.8786,
    y2: 67.9262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10391_36887",
    x1: 83.9152,
    y1: 78.6902,
    x2: 78.3046,
    y2: 76.9577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0044699,
    stopColor: "#222C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B3753"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10391_36887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.4385,
    height: 132.16,
    fill: "white",
    transform: "translate(27 5.22656) rotate(-3.59141)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStone);
export default __webpack_public_path__ + "static/media/stone.70193fba5c84729c2fd46e5d001b710e.svg";
export { ForwardRef as ReactComponent };